import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';
const SmartTvIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        preserveAspectRatio="none"
        viewBox="-2 2 31 31"
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M26.946 8.916c0-1.242-.707-2.288-1.734-2.436H2.705C1.749 6.48.973 7.573.973 8.916v16.69c0 1.345.776 2.438 1.732 2.438h6.118c-.156.14-.313.286-.472.436-.363.347-.449 1.02-.189 1.507.158.296.409.453.661.453a.683.683 0 0 0 .47-.2c.833-.792 1.628-1.438 2.418-1.964l.36-.232h3.775c.912.567 1.822 1.285 2.778 2.194a.677.677 0 0 0 .47.202c.253 0 .502-.157.66-.453.261-.485.175-1.16-.188-1.506-.158-.15-.315-.296-.471-.437h6.117c.957 0 1.734-1.093 1.734-2.438V8.916ZM2.705 8.64l22.415-.007c.103.016.206.11.206.283v16.69c0 .168-.085.278-.114.278H2.705c-.03 0-.112-.11-.112-.278V8.916c0-.168.083-.276.112-.276Zm6.677 1.697c.323.412.336 1.096.027 1.528l-4.77 6.676c-.16.221-.373.334-.587.334-.2 0-.402-.098-.56-.298-.322-.412-.335-1.096-.026-1.528l4.77-6.675c.308-.43.82-.452 1.146-.037Zm-3.113 1.405c.31-.43.3-1.113-.021-1.527-.321-.414-.833-.401-1.145.028l-1.634 2.26c-.31.428-.3 1.114.02 1.527.158.203.361.302.563.302.212 0 .424-.11.583-.33l1.634-2.26Z"
          fill="inherit"
        />
      </svg>
    );
  }
);
export default SmartTvIcon;
